import { colors } from '@alixpartners/ui-components';
import styled, { css } from 'styled-components';
import { rgba } from 'polished';

const borderColor = '#979797';

const widthMixin = width => css`
	width: ${width};
	min-width: ${width};
	max-width: ${width};
`;

const firstColWidthStyle = widthMixin('23%');
const secondColWidthStyle = widthMixin('44%');

export const Wrapper = styled.div`
	div {
		box-sizing: border-box;
	}
`;

export const Title = styled.div`
	font-size: 11px;
	font-style: normal;
	font-weight: 400;
	line-height: 13px;
	letter-spacing: 0.8px;
	text-align: left;
	text-transform: uppercase;
	color: ${colors.grey5};
`;

export const TableWrapper = styled.div`
	margin-top: 16px;
	background: white;
`;

export const Table = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid ${borderColor};
`;

export const Cell = styled.div`
	border-left: 1px solid ${borderColor};
	flex-grow: 1;
	font-weight: 400;

	${widthMixin('calc(50% - 89px)')};

	:first-child {
		${widthMixin('160px')};
		border-left: none;
	}
`;

export const MainHeader = styled.div`
	display: flex;
	width: 100%;
	height: 33px;

	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 36px;
	letter-spacing: 0.3px;
	text-align: center;

	color: ${colors.grey5};
`;

export const SecondaryHeader = styled.div`
	display: flex;
	flex-direction: row;
	border-top: 1px solid ${borderColor};
	height: 39px;
	line-height: 54px;

	font-size: 11px;
	font-style: normal;
	font-weight: 400;
	letter-spacing: 0px;

	color: ${colors.grey5};

	${Cell} {
		display: flex;
		flex-direction: row;
		text-align: right;
		padding-bottom: 4px;

		> div {
			flex-grow: 1;
			line-height: 13px;
			padding-left: 4px;

			display: flex;
			justify-content: flex-end;
			align-items: flex-end;
			flex-direction: column;

			font-weight: 400;

			:first-child {
				${firstColWidthStyle};
			}
			:nth-child(2) {
				${secondColWidthStyle};
			}
			:last-child {
				padding-right: 6%;
			}
		}

		:first-child {
			font-size: 13px;
			font-style: normal;
			font-weight: 500;
			letter-spacing: 0.3px;
			text-align: left;
			line-height: 52px;
			padding-left: 5px;

			text-align: left;

			color: ${colors.grey7};
		}
		:last-child {
			padding-left: 24px;

			> div {
				:first-child {
					${firstColWidthStyle};
				}
				:nth-child(2) {
					${widthMixin('48%')};
				}
				:last-child {
					padding-right: 2%;
				}
			}
		}
	}
`;

export const Row = styled.div`
	display: flex;
	flex-direction: row;
	border-top: 1px solid ${borderColor};
	height: 41px;
	line-height: 54px;

	color: ${colors.grey5};

	${Cell} {
		display: flex;
		flex-direction: row;
		text-align: right;
		padding-bottom: 4px;

		> div {
			flex-grow: 1;
			line-height: 13px;
			padding-left: 4px;

			display: flex;
			justify-content: flex-end;
			align-items: flex-end;
			flex-direction: column;

			font-weight: 300;

			:first-child {
				${firstColWidthStyle};
			}
			:nth-child(2) {
				${secondColWidthStyle};
			}
			:last-child {
				padding-right: 6%;
			}
		}

		:first-child {
			line-height: 40px;
			padding-left: 11px;
			align-items: center;
		}

		:last-child {
			padding-left: 24px;

			> div {
				:first-child {
					${firstColWidthStyle};
				}
				:nth-child(2) {
					${widthMixin('48%')};
				}
				:last-child {
					padding-right: 2%;
				}
			}
		}
	}

	${Cell}, ${Cell}:first-child {
		font-size: 16px;
		font-style: normal;
		line-height: 24px;
		letter-spacing: 0px;
		padding-bottom: 2px;

		> div {
			font-weight: 400;
			color: ${colors.grey7};
			justify-content: center;
		}
	}

	:first-child {
		background: pink;
	}

	:nth-child(3) {
		background: ${rgba('#939DF3', 0.25)};
	}
	:nth-child(4) {
		background: ${rgba('#0696A6', 0.25)};
	}

	:nth-child(n + 5) {
		background: ${rgba('#0696A6', 0.1)};
		height: 28px;
		border-color: transparent;

		${Cell} {
			font-size: 13px;
			font-style: normal;
			font-weight: 400;
			line-height: 19px;
			letter-spacing: 0.3px;
			text-align: left;

			:first-child {
				padding-left: 13px;
				padding-bottom: 0;
				padding-top: 4px;
			}
		}
	}
`;
